import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_REQUEST_LIST = 'GET_REQUEST_LIST';
export const GET_REQUEST_LIST_SUCCESS = 'GET_REQUEST_LIST_SUCCESS';
export const GET_REQUEST_LIST_FAILURE = 'GET_REQUEST_LIST_FAILURE';

// Action Creators
export const getRequestList = () => ({
  type: GET_REQUEST_LIST,
});

export const getRequestListSuccess = (users) => ({
  type: GET_REQUEST_LIST_SUCCESS,
  payload: users,
});

export const getRequestListFailure = (error) => ({
  type: GET_REQUEST_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const getRequestListData = (external, tab, pageCount) => {
  return async (dispatch) => {
    dispatch(getRequestList());
    try {
      let requesrListUrl = '';
      if (tab === 1) {
        requesrListUrl = url?.requestList;
        if (pageCount !== undefined) {
          requesrListUrl += `?page=${pageCount}`;
        }
      } else if (tab === 2) {
        requesrListUrl = url?.requestList + '?in_review=1';
        if (pageCount !== undefined) {
          requesrListUrl += `?page=${pageCount}`;
        }
      } else if (tab === 3) {
        requesrListUrl = url?.requestList + '?is_approved=1';
        if (pageCount !== undefined) {
          requesrListUrl += `?page=${pageCount}`;
        }
      } else if (tab === 4) {
        requesrListUrl = url?.requestList + '?on_hold=1';
        if (pageCount !== undefined) {
          requesrListUrl += `?page=${pageCount}`;
        }
      }
      const response = await getMethodWithToken(requesrListUrl);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getRequestListSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getRequestListFailure(error?.message));
    }
  };
};
